import { z } from "zod";
import { ReturnProductSchema } from "../draft-return/draft-return-items";

export const getWarrantyEligibleProductsSchema = {
  input: z.object({}).nullish(),
  output: z.object({ eligibleProducts: z.array(ReturnProductSchema) }),
};
